module.exports = __webpack_public_path__ + "img/profilman.7115f741.svg";